<div id="timeoutCountdown" *ngIf="idleTimeoutCountdownSeconds > 0">
  <span class="timeout-countdown"
    >This page will logout in {{ idleTimeoutCountdownString }}. Click anywhere
    on the page to resume.</span
  >
</div>
<header class="fixed-top">
  <nav class="navbar navbar-expand navbar-dark">
    <a class="navbar-brand mnav" href="#"
      ><img
        src="../assets/images/logowhite.svg"
        style="height: 48px"
        alt="Everlight Logo"
    /></a>
    <div
      class="collapse navbar-collapse justify-content-start"
      id="navbarcontent"
    >
      <app-org-site-selection></app-org-site-selection>
      <ul class="navbar-nav ml-auto" [hidden]="(user$ | async) === null">
        <li class="nav-item">
          <app-context-menu
            [user$]="user$"
            (logout)="logout()"
          ></app-context-menu>
        </li>
      </ul>
    </div>
  </nav>
</header>
<div class="d-flex flex-column vh-100">
  <div id="main-content" class="mb-2 d-flex flex-grow-1 overflow-fix">
    <section class="flex-fill">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </section>
  </div>
  <footer class="footer mt-auto mb-2 mx-5">
    <div class="footerdiv py-2">
      <a
        href="https://www.everlightradiology.com/au"
        target="_blank"
        rel="noopener"
        class="navbar-brand text-white my-1 py-2"
        >Everlight Radiology</a
      >
      &copy;Copyright 2020-{{ copyrightYear }}
    </div>
  </footer>
</div>
